import { create } from 'zustand';

type Liability1003Store = {
  selectedLiabilityId: number | null;
  setSelectedLiabilityId: (liabilityId: number | null) => void;
};

export const useLiability1003Store = create<Liability1003Store>()((set) => ({
  selectedLiabilityId: null,
  setSelectedLiabilityId: (liabilityId: number | null) =>
    set({ selectedLiabilityId: liabilityId }),
}));
